// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"79294a10","703":"ede009c8"}[chunkId] + ".chunk.js";
};